import React, { useEffect, useMemo, useState, useCallback } from 'react';
import _ from 'lodash';
import { useDebounce } from 'barnyard/hooks';
import PropTypes from 'prop-types';
import { Input, Tag, Label } from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { checkValidIncentive } from '../actions';

const classNamePrefix = 'Incentives__IncentiveApply';
const IncentiveApplyPromotion = ({
  onChange,
  placeholder,
  notFoundContent,
  label,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [promotion, setPromotion] = useState('');
  const [options, setOptions] = useState({});
  const debouncedValue = useDebounce(promotion, 500);

  const loadingTrue = useCallback(() => setLoading(true), []);

  useEffect(() => {
    if (_.isEmpty(debouncedValue)) {
      return;
    }
    checkValidIncentive(
      debouncedValue,
      loadingTrue,
      (res) => { setOptions(res); setLoading(false); },
    );
  }, [debouncedValue, loadingTrue]);

  const resultOfInput = useMemo(
    () => {
      if (loading || _.isEmpty(debouncedValue)) {
        return <Tag className={`${classNamePrefix}__empty`} fins='left' size='sm'>Invalid</Tag>;
      }
      if (options.is_valid) {
        return <Tag className={`${classNamePrefix}__result`} color='green' fins='left' size='sm'>Applied!</Tag>;
      }
      if (options.is_expired) {
        return <Tag className={`${classNamePrefix}__result`} color='red' fins='left' size='sm'>Expired</Tag>;
      }
      return <Tag className={`${classNamePrefix}__result`} color='red' fins='left' size='sm'>Invalid</Tag>;
    }, [options, debouncedValue, loading]
  );

  return (
    <div className={classNamePrefix} >
      <Row justify='edges' >
        <Col span={0} align='end'><Label>{label}</Label></Col>
        <Col span={0}>{resultOfInput}</Col>
      </Row>
      <Input
        placeholder={placeholder}
        notFoundContent={notFoundContent}
        value={promotion}
        onChange={setPromotion}
        loading={true}
        {...props}
      >
      </Input>
    </div>
  );
};

IncentiveApplyPromotion.defaultProps = {
  label: 'Apply Promotion Code',
  placeholder: 'Apply code',
  notFoundContext: 'Promotion Code not found'
};

IncentiveApplyPromotion.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  notFoundContent: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default IncentiveApplyPromotion;
